// extracted by mini-css-extract-plugin
module.exports = {"priceAdjustment":"detail_priceAdjustment_1WfWv"};